<template>
    <div class="listmain ">
         <h1 class="firTitle">技能请求响应协议</h1>
     <h3 class="sedTitle">标准请求</h3>
              <p>猎户语音OS将本次语音的识别及解析信息以及其他扩展信息发送给开发者，开发者可根据该信息对该请求信息进行相关的逻辑处理。需要重点关注“request”字段信息。
               <br>
               猎户语音OS通过HTTP协议发送post请求到用户技能网关，技能网关应在5秒内响应结果，如未能及时响应，OrionOS将抛弃该请求
              </p>
              <h5 class="thirdTitle">请求头信息：</h5>
              <p>HTTP Header
                <br>POST :  /intent/invoke HTTP/1.1
                <br>Content-Type : application/json;charset=UTF-8
                <br>Host : ovs.ainirobot.com
                <br>Content-Length:
                <br>Accept : application/json
                <br> Accept-Charset : utf-8

              </p>
               <h5 class="thirdTitle">请求内容格式规范及参数说明</h5>
               <highlight-code lang="javascript">
               <span>
                {
    "vserion": "0.2.0",
    "request": {
        "type": "IntentRequest",
        "nlu": {},
        "asr": {
            "text": "语音识别文本"
        }
    }，
    "session": {
        "sessionId": "3123132123",
        "attributes": {
            "a": "b",
            "c": "d"
        },
        "application": {
            "client": {
                "clientId": "orion.ovs.client.1501826808675",
                "ucenter": {
                    "clientId": "orion.ucenter.5ae7ab0c5a1cebcf",
                    "secret": "xxerwerewrewrewr"
                }
            },
            "skill": {
                "skillId": "orion.ovs.skill.1504611578838",

                "linkAccount": {
                    "15": {
                        "xxxx": "yyyy"
                    }
                }
            }
        },
        "user": {
            "isLogin": false,
            "openId": "2WzaJr2xScwL5Lj7tiIcKQ==",
            "userId": "1234455",
            "unionAccessToken": "esbCIsImlzcyI6Imh0dHA6Ly9hcGkuY2hpbGQuY21jbS5jb20iLCJleHAiOj"
        }
    },
    "context": {
        "System": {
            "device": {
                "deviceType": "",
                "deviceId": "",
                "lat": "",
                "lng": "",
                "version": ""
            },
            "params": {}
        }
    }
}
               </span>
              </highlight-code>
     <p><b class="thirdTitle">参数说明</b></p>
     <br>
     <table style="width:auto;color:#24292E;font-family:-apple-system, system-ui, 微软雅黑, &quot;font-size:14px;">
      <tbody>
      <tr>
       <th style="border:1px solid #DFE2E5;">
        Function
       </th>
       <th style="border:1px solid #DFE2E5;">
        Name
       </th>
       <th style="border:1px solid #DFE2E5;">
        Type
       </th>
       <th style="border:1px solid #DFE2E5;">
        destribution
       </th>
      </tr>
      </tbody>
      <tbody>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        vserion
       </td>
       <td style="border:1px solid #DFE2E5;">
        version
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        系统版本号
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        会话信息
       </td>
       <td style="border:1px solid #DFE2E5;">
        session
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        会话相关信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -sessionId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        猎户语音OS生成的唯一会话ID，每次请求都会生成新的sessionId
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -attributes
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        开发者自定义的会话属性信息，用于保存会话信息【后台需要把context字段勾选才会生效，后续优化：前端同样应该增加用户可选择的按钮】
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        -会话应用信息
       </td>
       <td style="border:1px solid #DFE2E5;">
        -application
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        技能开发者不需要关注该信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --client
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        接入猎户OS的客户端基本信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---clientId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        猎户语音OS的客户端唯一标识
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---ucenter
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        猎户语音OS用户中心唯一标识
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----clientId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        猎户语音系统（OVS）客户端关联的用户中心ClientID
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----secret
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        该猎户语音系统（OVS）客户端关联的用户中心Secret
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        --会话技能信息
       </td>
       <td style="border:1px solid #DFE2E5;">
        --skill
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        开发者在开放平台前端页面“配置服务”“授权信息”进行设置后，会透传的信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---skillId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        该次请求所访问的技能的skillID
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---linkAccount
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        该次请求所访问的第三方资源鉴权信息，【智能家居技能必须填写该信息，App端默认支持第三方登录功能】【自定义技能根据需要填写该信息，App端的登录需要开发者自己开发】
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----自定义
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        "15"为资源平台ID，内部JSONObject详细信息和资源平台对应
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        -用户基本信息
       </td>
       <td style="border:1px solid #DFE2E5;">
        -user
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        发起本次请求的用户基本信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --isLogin
       </td>
       <td style="border:1px solid #DFE2E5;">
        Boolean
       </td>
       <td style="border:1px solid #DFE2E5;">
        判断用户是否已经登录
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --openId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        分配给第三方使用的UserID，建议开发者可以使用该字段保存用户的ID信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --userId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        系统内部的唯一ID，通常情况下不会给开发者进行使用
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --unionAccessToken
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        系统内部的用户登录凭证，开发者不需要关注
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        智能硬件基本信息
       </td>
       <td style="border:1px solid #DFE2E5;">
        context
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        发起请求的搭载猎户语音OS的智能硬件（如智能音箱）基本信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -System
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        系统相关信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --device
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        设备相关信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---deviceType
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        设备类型
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---deviceId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        设备ID
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---lat
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        经度
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---lng
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        维度
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---version
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        当前版本号
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --params
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        智能硬件（如智能音箱）基本信息的扩展信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        语音识别及解析基本信息
       </td>
       <td style="border:1px solid #DFE2E5;">
        request
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        发起请求的语音识别以及解析的基本信息，开发者需要重点关注
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -type
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        默认为"IntentRequest",不需要修改
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -nlu
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        详见NLU协议，具体展示方式按照开发者配置的交互模型展示
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -asr
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        语音识别信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --text
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        语音识别文本信息
       </td>
      </tr>
      </tbody>
     </table>
     <h3 class="sedTitle">标准响应</h3>
     <p>开发者将该信息发送给猎户语音OS即可实现对智能硬件（智能音箱及移动App）的控制。需重点关注“outSpeech（TTS播报）”和“directives（控制指令）”信息。当前智能硬件端（如智能音箱）仅支持TTS+Audio的播报方式。
      <br>
      用户技能网关通过HTTP协议响应JSON数据，OrionOS网关应在5秒内响应结果，如未能及时响应，OrionOS将抛弃该请求。
     </p>
     <h5 class="thirdTitle">请求头信息：</h5>
     <highlight-code lang="javascript">
      <span>
      HTTP/1.1 200 OK
Content-Type:application/json:charset=UTF-8
Content-Length:
      </span>
     </highlight-code>
     <h5 class="thirdTitle">请求内容格式规范及参数说明：</h5>
     <highlight-code lang="javascript">
      <span>
     {
	"version": "0.1.1",
	"response": {
		"outSpeech": {
			"type": "text",
			"text": "这是要转换成语音的文字"
		},
		"display": {
			"type": "DISPLAY.[XXXXX]",
			"data": {}
		},
		"card": {
			"text": "",
			"popup": "",
			"ui": [{
				"type": "Simple（1）/Image（2）/ImageText（3）/ImageTextButtion（4）/Weather（C1）/WeatherAirQuality（C2）",
				"bg": {
					"coler": "",
					"image": "",
					"virtual": false
				},
				"attr": {
					"title": "",
					"subTitle": "",
					"image": "",
					"button": {
						"text": "",
						"link": ""
					},
					"link": ""
				},
				"custom": {},
				"skillIcon": {
					"name": "",
					"image": ""
				}
			}],
			"linkAccount": {
				"skillId": "orion.ovs.skill.1510212090177",
				"platformId": "22",
				"title": "",
				"subTitle": "",
				"icon": "",
				"data": {}
			}
		},
		"directives": [{
				"type": "AudioPlayer.Play",
				"audioItem": {
					"stream": {
						"url": ""
					}
				},
			},
			{
				"type": "SkillSession.Begin",
				"attributes": {
					"a": "b",
					"c": "d"
				},
				"context": "normal"
			}
		]
	}
}
      </span>
     </highlight-code>
     <h5 class="thirdTitle">参数信息：</h5>
     <table style="width:auto;color:#24292E;font-family:-apple-system, system-ui, 微软雅黑, &quot;font-size:14px;">
      <tbody>
      <tr>
       <th style="border:1px solid #DFE2E5;">
        Function
       </th>
       <th style="border:1px solid #DFE2E5;">
        Name
       </th>
       <th style="border:1px solid #DFE2E5;">
        Type
       </th>
       <th style="border:1px solid #DFE2E5;">
        destribution
       </th>
      </tr>
      </tbody>
      <tbody>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        vserion
       </td>
       <td style="border:1px solid #DFE2E5;">
        version
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        系统版本号
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        response
       </td>
       <td style="border:1px solid #DFE2E5;">
        response
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        响应内容格式规范及参数说明
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        -TTS的播报
       </td>
       <td style="border:1px solid #DFE2E5;">
        -outSpeech
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        TTS的播报信息,配置该信息后智能硬件（如智能音箱）会播报TTS语音
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --type
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        输出的语音类型,取值类型：text、ssml，目前暂不支持ssml协议
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --text
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        文本合成语音的文字
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        -屏幕View展示信息（适用于带屏智能硬件）
       </td>
       <td style="border:1px solid #DFE2E5;">
        -display
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        屏幕的View展示信息透传到带屏智能硬件（如带屏智能音箱），
        开发者自行处理View样式，如果是无屏智能硬件（如智能音箱），开发者不需要关注
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --type
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        显示数据的数据类型，取值类型：DISPLAY.[XXXXXX] ,
        开发者需要遵循该定义规则以DISPLAY.开头[XXXXX]为自定义内容
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --data
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        开发者自定义并自行解析，该字段需要与上面DISPLAY进行统一定义，和业务相关
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        -移动端App信息流卡片View展示信息
       </td>
       <td style="border:1px solid #DFE2E5;">
        -card
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        移动APP端的信息流卡片View展示信息透传到移动App端，
        开发者自行处理View样式，同时必须填写下方的授权登录信息“linkAccount”字段，默认不需要填写
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --text
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        输出的文本信息，如果为空该信息不限制
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --popup
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        手机APP是否允许直接弹窗，Pop(弹出)、Auto（自动：依赖于客户端逻辑，兼容之前）
        ，Forbid(禁止，客户端在任何情况下都不允许弹出)
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --ui
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONArray/JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        信息流卡片的View展示效果，该字段中的数据根据type类型中的数据进行变化。
        如果数据不存在情况下为：null
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---type
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        不同的展示类型卡片具有不同的展示样式。
        取值范围：Simple（1）/Image
        （2）/ImageText
        （3）/ImageTextButtion
        （4）/Weather（C1） /WeatherAirQuality（C2）
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---bg
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        信息流卡片背景定义
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----coler
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        背景颜色
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----image
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        背景图片
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----virtual
       </td>
       <td style="border:1px solid #DFE2E5;">
        Boolean
       </td>
       <td style="border:1px solid #DFE2E5;">
        是否虚化
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---attr
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        信息流卡片属性定义
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----title
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        标题
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----subTitle
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        二级标题
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----image
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        图片
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----button
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        按钮定义
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -----text
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        按钮的文本描述
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -----link（button下的link）
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        按钮的跳转链接
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----link（attr下的link）
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        信息流卡片的跳转链接
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---custom
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        针对于定制的样式使用该字段，定制的样式现在包括：Weather、WeatherAirQuality
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---skillIcon
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        信息流卡片角标定义
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----name
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        角标名称
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----image
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        角标名称
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        --linkAccount
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        信息流卡片的授权登录透传信息，关联账号，如果用户没有登录，
        技能可以追加该Card信息进行LinkAccount功能的引导。
        如果开发者定义了上述信息流卡片信息，则该部分字段必填
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---skillId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        技能ID
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---platformId
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        技能的资源平台ID
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---title
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        登录Title
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---subTitle
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        登录二级Title
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---icon
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        登录的Icon图片
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---data
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        与账号关联相关的业务数据，该字段可以存放埋点需要进行上报的数据，开发者不需要关注
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        -控制指令
       </td>
       <td style="border:1px solid #DFE2E5;">
        -directives
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONArray/JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        开发者期望技能的具体执行控制指令信息，开发者需要重点关注
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        --音频播放
       </td>
       <td style="border:1px solid #DFE2E5;">
        --自定义
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        当Type定义为AudioPlayer.Play，该协议 为音频播放控制指令
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---type
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        音频播放默认字段：AudioPlayer.Play，开发者不需要修改
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---audioItem
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        音频字段信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ----stream
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        音频流基本信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        -----url
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        音频流的播放的URL
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">

       </td>
       <td style="border:1px solid #DFE2E5;">
        Boolean
       </td>
       <td style="border:1px solid #DFE2E5;">
        是否拥有下一首歌曲，如果有下一首歌曲，
        客户端在播放结束的时候会进行虚拟意图autoNext的请求。
        目前开放平台在线测试并不支持，实际智能硬件（如智能音箱）支持该功能。
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
        --保存会话信息
       </td>
       <td style="border:1px solid #DFE2E5;">
        --自定义
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        开发者若填写该信息，会在下一次的标准请求“session-attributes”中携带该信息，
        意味着开发者可以保留部分会话信息，开发者根据需要填写以下字段信息。
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---type
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        会话类型信息,通过该字段可以灵活的控制skill会话的保持与退出，
        会话状态：开始SkillSession.Begin/ 运行SkillSession.Running/结束SkillSession.End"。
        当会话状态为“开始/运行”时下次请求会携带本次会话信息，当会话状态标记为“结束”时，
        下一次请求自动清空attributes中的属性信息。
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---attributes
       </td>
       <td style="border:1px solid #DFE2E5;">
        JSONObject
       </td>
       <td style="border:1px solid #DFE2E5;">
        用户可自定义会话属性信息
       </td>
      </tr>
      <tr>
       <td style="border:1px solid #DFE2E5;">
       </td>
       <td style="border:1px solid #DFE2E5;">
        ---context
       </td>
       <td style="border:1px solid #DFE2E5;">
        String
       </td>
       <td style="border:1px solid #DFE2E5;">
        默认填写信息为：normal，开发者不需要关注<br />
       </td>
      </tr>
      </tbody>
     </table>


     <h3 class="sedTitle">简单范例</h3>
     <b class="thirdTitle">1.实现简单的TTS播报的响应JSON</b>
     <highlight-code lang="javascript">
      <span>
     {
    "version": "0.1.1",
    "response": {
        "outSpeech": {
            "type": "text",
            "text": "这是要转换成语音的文字"
        }
    }
}
      </span>
     </highlight-code>
     <b class="thirdTitle">2.实现简单的音频播放的JSON范例</b>
     <highlight-code lang="javascript">
      <span>
    {
    "version": "0.1.1",
    "response": {
        "directives": [{
            "type": "AudioPlayer.Play",
            "audioItem": {
                "stream": {
                    "url": ""
                }
            },
        }]
    }
}
      </span>
     </highlight-code>
     <b class="thirdTitle">3.实现简单的TTS播放+音频资源播放</b>
     <highlight-code lang="javascript">
      <span>
   {
    "version": "0.1.1",
    "response": {
        "outSpeech": {
            "type": "text",
            "text": "这是要转换成语音的文字"
        },
        "directives": [{
            "type": "AudioPlayer.Play",
            "audioItem": {
                "stream": {
                    "url": ""
                }
            }
        }]
    }
}
      </span>
     </highlight-code>
    </div>
</template>

<script>
export default {
  name: "Ptjj"
};
</script>

<style  rel="stylesheet/scss" lang="scss" scoped>

  h1,
  h2,
  h3,
  h4,
  h5 {
    padding: 0;
    margin: 0px;
    font-weight: normal;
  }

  ul,
  li {
    list-style: none;
  }



  .listmain {
    font-size: 14px;
    line-height: 26px;
    .firTitle {
      font-size: 20px;
      color: #1e4d79;
      margin-bottom: 30px;
    }
    .sedTitle {
      font-size: 16px;
      font-weight: bold;
      padding-bottom: 10px;
      border-bottom: 1px solid #f3f3f3;
      margin-bottom: 15px;
      margin-top: 50px;
      &.fir {
        margin-top: 0px;
      }
    }
    .thirdTitle{
      margin-top: 50px;
      font-weight: bold;
      line-height: 26px;
    }
    .codeTitle{
      font-weight: bold;
      line-height: 26px;
    }
    pre{
      margin-top: 20px;
    }
    img {
      margin: 30px 0;
    }
    table,
    table tr th,
    table tr td {
      border: 1px solid #000;
      text-align: center;
    }
    table {
      line-height: 30px;
      width: 100%;
      border-collapse: collapse;
    }
  }

  .el-submenu .el-menu-item {
    min-width: 190px;
    background: #f5f5f5;
  }

  .el-submenu {
    min-width: 190px;
    background: #f5f5f5;
  }

  img {
    margin-top: 30px;
    margin-bottom: 30px;
  }

</style>




// WEBPACK FOOTER //
// src/components/tutor/zdyjn_qqxy.vue